import type { ReactNode } from 'react'
import { Button as AriaButton } from 'react-aria-components'
import { useNavigate } from 'react-router'
import { Dropdown } from '@/components/base/dropdown/dropdown'
import { api } from '../api/client'
import { useShell } from '../store'

/**
 * The one account menu (audit P2-19): the page-bar avatar and the tree footer both open it, so there is
 * no inert twin. Profile and security, Settings, Keyboard shortcuts, Sign out (PRD-016 §5).
 */
export function AccountMenu({ children, label = 'Account menu', testId = 'account-menu', className }: { children: ReactNode, label?: string, testId?: string, className?: string }) {
  const { setSheetOpen } = useShell()
  const navigate = useNavigate()
  const signOut = async () => {
    await api('/auth/sign-out', { method: 'POST', json: {} }).catch(() => undefined)
    window.location.assign('/signin')
  }
  return (
    <Dropdown.Root>
      <AriaButton aria-label={label} className={className ?? 'rounded-full outline-focus-ring focus-visible:outline-2 focus-visible:outline-offset-2'} data-testid={testId}>
        {children}
      </AriaButton>
      <Dropdown.Popover placement="bottom end">
        <Dropdown.Menu onAction={(key) => {
          if (key === 'security')
            navigate('/settings/security')
          else if (key === 'settings')
            navigate('/settings/general')
          else if (key === 'shortcuts')
            setSheetOpen(true)
          else if (key === 'signout')
            void signOut()
        }}
        >
          <Dropdown.Item id="security" label="Profile and security" />
          <Dropdown.Item id="settings" label="Settings" />
          <Dropdown.Item id="shortcuts" label="Keyboard shortcuts" />
          <Dropdown.Separator />
          <Dropdown.Item id="signout" label="Sign out" />
        </Dropdown.Menu>
      </Dropdown.Popover>
    </Dropdown.Root>
  )
}
